import React from 'react'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'

import GuidanceNote from '../../../../components/GuidanceNote'
import { REFUND_APPROVAL_TEXT } from '../../../constants/refundApprovalText'
import {
  UI_COLOR_ACCENT_ORANGE,
  UI_COLOR_ACCENT_ORANGE_SOFT_HOVER,
  UI_COLOR_TEXT_NEUTRAL
} from '../../../../constants/uiColors'

const RefundNcrGuidanceNote = () => (
  <GuidanceNote
    title=""
    message={REFUND_APPROVAL_TEXT.ncrPending}
    icon={<WarningAmberOutlinedIcon />}
    accentColor={UI_COLOR_ACCENT_ORANGE}
    backgroundColor={UI_COLOR_ACCENT_ORANGE_SOFT_HOVER}
    textColor={UI_COLOR_TEXT_NEUTRAL}
    singleLine
    sx={{
      mb: 2,
      px: { xs: 1.5, md: 2.5 },
      py: { xs: 1.25, md: 1.5 },
      borderRadius: { xs: '6px', md: '8px' },
      borderLeft: {
        xs: `3px solid ${UI_COLOR_ACCENT_ORANGE}`,
        md: `4px solid ${UI_COLOR_ACCENT_ORANGE}`
      }
    }}
    headerSx={{
      alignItems: { xs: 'flex-start', md: 'center' },
      flexWrap: 'nowrap',
      columnGap: { xs: 1, md: 0.5 },
      rowGap: 0
    }}
    iconSx={{
      mt: { xs: 0.1, md: 0 },
      mr: { xs: 0, md: 0.5 },
      ml: { xs: 0, md: -0.5 },
      '& svg': {
        fontSize: { xs: 18, md: 20 }
      }
    }}
    titleSx={{ display: 'none' }}
    messageSx={{
      flex: { xs: '1 1 auto', md: '0 1 auto' },
      minWidth: 0,
      fontSize: { xs: 12.5, md: 13 },
      lineHeight: { xs: 1.45, md: 1.5 }
    }}
  />
)

export default RefundNcrGuidanceNote
